import { useAuth } from '../contexts/AuthContext';

export const usePermissions = () => {
  const { user } = useAuth();

  const hasPermission = (resource, action) => {
    if (!user) return false;
    
    // Yönetici her şeyi yapabilir
    if (user.role === 'yonetici') return true;
    
    // Kullanıcının bu kaynak için yetkisi var mı kontrol et
    return user.permissions?.[resource]?.[action] || false;
  };

  const canView = (resource) => hasPermission(resource, 'view');
  const canCreate = (resource) => hasPermission(resource, 'create');
  const canEdit = (resource) => hasPermission(resource, 'edit');
  const canDelete = (resource) => hasPermission(resource, 'delete');
  const canManageTeam = () => hasPermission('team', 'manage');
  const canExportAnalytics = () => hasPermission('analytics', 'export');
  const canGenerateReports = () => hasPermission('reports', 'generate');
  const canManageBlog = () => user?.role === 'yonetici' || user?.role === 'blogger' || hasPermission('blog', 'manage');

  return {
    hasPermission,
    canView,
    canCreate,
    canEdit,
    canDelete,
    canManageTeam,
    canExportAnalytics,
    canGenerateReports,
    canManageBlog,
    isAdmin: user?.role === 'yonetici',
    isBlogger: user?.role === 'blogger'
  };
};